const ServicesStep = () => true;

const ServiceDetailsStep = () => true;

const ContactDetailsStep = ({ errors, user }) => (
  !errors.address
  && !errors.unitNumber
  && !errors.date
  && !errors.time
  && (!user.email ? !errors.email : true)
);

export default [
  ServicesStep,
  ServiceDetailsStep,
  ContactDetailsStep,
];
